import { useState } from 'react'
import Icon from 'components/Icon'
import Button from 'components/form/Button'
import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'
import ad from 'api/axios/foka/ad'
import { useAlert } from 'features/dialog/Alert'
import { useHistory, useParams } from 'react-router-dom'
import { useDialog } from 'features/dialog/Dialog'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { DashboardTypes } from 'features/Codes'
import CreateAdGroupModal from 'features/dashboard/operation/createAdGroup/CreateAdGroupModal'
import { DASHBOARD_REFERRER } from 'features/ad/useDashboardReferrer'

const CreateAdGroupButton = ({ type = 'button' }) => {
  const { accountId } = useParams()
  const { selectedIds } = useDashboardTableSelector(DashboardTypes.CAMPAIGN)
  const [disabled, setDisabled] = useState(false)
  const history = useHistory()
  const [FailedAlert, showFailedAlert] = useAlert()
  const [CreateAdGroup, showCreateAdGroup, hideCreateAdGroup] = useDialog()

  const createAdGroup = async campaignId => {
    setDisabled(true)
    try {
      const {
        data: { generable },
      } = await ad.getAdGroupGenerable(campaignId)
      if (generable === false) {
        showFailedAlert()
      } else {
        history.push(
          `/${accountId}/ads/campaigns/${campaignId}/groups/new?from=${DASHBOARD_REFERRER.AD_GROUP}`
        )
      }
    } catch (ignore) {}
    setDisabled(false)
  }

  const handleCreate = () => {
    if (selectedIds.length === 1) {
      const [id] = selectedIds
      createAdGroup(id)
    } else {
      showCreateAdGroup()
    }
  }
  return (
    <>
      {type === 'button' ? (
        <Button primary disabled={disabled} onClick={handleCreate}>
          <Icon className="img_comm" name="add" />
          광고그룹 만들기
        </Button>
      ) : (
        <NoneAnchor
          className="link_txt"
          onClick={handleCreate}
          style={disabled ? { pointerEvents: 'none' } : undefined}>
          광고그룹 만들기
        </NoneAnchor>
      )}
      <CreateAdGroup type="basic_layer" className="create_layer">
        <CreateAdGroupModal
          handleClose={hideCreateAdGroup}
          handleCreate={createAdGroup}
        />
      </CreateAdGroup>
      <FailedAlert title="광고그룹 제한수 초과">
        개수 제한으로 광고그룹 만들기를 할 수 없습니다.
        <br />
        광고그룹 삭제후 다시 진행하세요.
      </FailedAlert>
    </>
  )
}
CreateAdGroupButton.propTypes = {
  type: PropTypes.oneOf(['button', 'link']),
}
export default CreateAdGroupButton
